import { motion, useScroll, useSpring } from "framer-motion";

/**
 * Thin platinum scroll-progress bar pinned to the very top of the viewport.
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    mass: 0.4,
  });

  return (
    <motion.div
      data-testid="scroll-progress"
      aria-hidden
      style={{ scaleX, transformOrigin: "0% 50%" }}
      className="fixed top-0 left-0 right-0 h-px bg-platinum z-[60] origin-left"
    />
  );
}
